// extracted by mini-css-extract-plugin
export default {"contentClassName":"AchievementsModal_contentClassName__TT-cI"};